import React from "react";
import { FormattedMessage } from "react-intl";

import { Add } from "components/Icons";

import "./style.scss";

const AddBlock = ({ addBlock, text = "ADD_ROW" }) => (
  <div className="add-row" onClick={addBlock}>
    <Add /> <FormattedMessage id={text} />
  </div>
);

export default AddBlock;
